import {Message, MessagePayload} from './types'

type filterStudentsByClassAndDivisionProps = {
  students: any[]
  selectedClass: string
  selectedDivision: string
}

export const filterStudentsByClassAndDivision = ({
  students,
  selectedClass,
  selectedDivision,
}: filterStudentsByClassAndDivisionProps) => {
  return students.filter((student) => {
    // Apply class filter only if selectedClass is provided
    const isClassMatch = selectedClass ? student.class === selectedClass : true

    // Apply division filter only if selectedDivision is provided
    const isDivisionMatch = selectedDivision ? student.division === selectedDivision : true

    // Return true if both filters are satisfied (or skipped if not provided)
    return isClassMatch && isDivisionMatch
  })
}

const recieverTypeEnum = {
  all: 'All student',
  specific: 'specific',
  standard: 'specific',
}

export const prepareMessagePayload = (data: MessagePayload) => ({
  sender_id: data.senderId,
  sender_type: data.senderType,
  // standard value is used only in front end there is only all and specific type available
  receiver_type: recieverTypeEnum[data.receiverType],
  message_type: data.messageType,
  template_type: data.templateType,
  content: data.content,
  class: data.class_Name,
  division: data.divisionName,
  student_ids: data.studentIds,
  date_from: data.dateFrom,
  date_to: data.dateTo,
})

const getRecieverType = (data: any): Message['receiverType'] => {
  if (data.receiver_type === 'All student') {
    return 'all'
  } else if (data.student_ids.length > 0) {
    return 'specific'
  }
  return 'standard'
}

export const transformMsgResponse = (responseData: any) =>
  responseData.map((item: any) => ({
    id: item.message_id || 0,
    senderId: item.sender_id,
    senderType: item.sender_type,
    receiverType: getRecieverType(item),
    messageType: item.message_type,
    templateType: item.template_type,
    content: item.content,
    class_Name: item.class || null,
    divisionName: item.division || null,
    studentIds: item.student_ids || [],
    students: item.student_details || [],
    parents: item.parent_details || [],
    sentAt: item.created_at,
    dateFrom: item.date_from,
    dateTo: item.date_to,
  }))
